import type { LicensingRule, LicensingRuleType } from '../../../shared/model-typings';

/**
 * Used to determine if a license is in a policy when displaying policy rules in specific columns
 * @param ruleType the LicensingRuleType for a specific rule in a policy
 * @param policyRuleType the LicensingRuleType for the column
 */
export const isLicenseInPolicy = (ruleType: LicensingRuleType, policyRuleType?: LicensingRuleType): boolean =>
  ruleType === policyRuleType;

/**
 * Used to determine if a license partial matches a given search term.
 */
export const doesSearchMatchLicense = (search: string, licenseId: string): boolean =>
  licenseId.toLowerCase().includes(search.toLowerCase());

/**
 * Used to filter the list of rules/licenses down to only those that match the search term and belong in the given column.
 * @param rules the full list of LicensingRules available for filtering
 * @param search the users search term
 * @param policyRuleType the LicensingRuleType for the column
 */
export const filterLicensesBySearch = (
  rules: LicensingRule[],
  search: string,
  policyRuleType?: LicensingRuleType,
): LicensingRule[] =>
  rules.filter((r) => {
    return doesSearchMatchLicense(search, r.licenseId) && isLicenseInPolicy(r.type, policyRuleType);
  });
